import axiosV2 from './_defaults/v2/anonymous';

export async function createView({ type, beachSlug }) {
    try {
        const response = await axiosV2.post(`/views`, { type, beachSlug });

        if (response.data) {
            return response.data;
        }
    } catch (error) {

        throw error;
    }
}